export default __webpack_public_path__ + "static/media/mode-29.9825de6b.svg";